export const animationSettings = {}
